import * as _4 from 'lodash4';
import {
  ChannelBuilderServant,
  IChannelBuilder
} from 'ui-ng-sgd-components/src/components/channel_component/channel_builder_servant.ts';
export interface IApplicationConfigurationModel {
  member_features: Record<string, boolean>;
  member_configs: Record<string, string>;
  institution_media_paths: Record<string, string>;
  LOGIN_HELP: IHelpResources;
  ADVISING_HELP: IHelpResources;
  TECHNICAL_HELP: IHelpResources;
  SELF_ALERT_HELP: IHelpResources;
}

export interface IHelpType {
  nk: string;
  channel: string;
  contact_label: string;
  contact_value: string;
  contact_display_value: string;
  rank: number;
  metadata: IChannelBuilder;
}

export interface IHelpResources {
  nk: string;
  title: string;
  description: string;
  footer: string;
  details: IHelpType[];
}

interface IHelpResourcesTypeDef {
  type: string;
  typeDef: Record<
    string,
    {
      type: string;
      defaultValue?: string | IHelpType[];
    }
  >;
}

export interface IApplicationConfiguration {
  model: IApplicationConfigurationModel;
  AppConfigDTD: {
    member_features: string;
    institution_media_paths: string;
    member_configs: {
      type: string;
      typeDef: string;
    };
    LOGIN_HELP: IHelpResourcesTypeDef;
    ADVISING_HELP: IHelpResourcesTypeDef;
    TECHNICAL_HELP: IHelpResourcesTypeDef;
    SELF_ALERT_HELP: IHelpResourcesTypeDef;
  };
  initialize: () => IApplicationConfigurationModel;
  update: (data: IApplicationConfigurationModel) => IApplicationConfigurationModel;
  isConfigLoaded: () => boolean;
  isFeatureEnabled: (key: string) => boolean;
  getConfigProperty: (key: string) => string;
  productName: () => string;
}

export class ApplicationConfiguration {
  model: IApplicationConfigurationModel = {
    member_features: {},
    member_configs: {},
    institution_media_paths: {},
    LOGIN_HELP: {
      nk: '',
      title: '',
      description: '',
      footer: '',
      details: []
    },
    ADVISING_HELP: {
      nk: '',
      title: '',
      description: '',
      footer: '',
      details: []
    },
    TECHNICAL_HELP: {
      nk: '',
      title: '',
      description: '',
      footer: '',
      details: []
    },
    SELF_ALERT_HELP: {
      nk: '',
      title: '',
      description: '',
      footer: '',
      details: []
    }
  };
  AppConfigDTD: {
    member_features: string;
    institution_media_paths: string;
    member_configs: {
      type: string;
      typeDef: string;
    };
    LOGIN_HELP: string;
    ADVISING_HELP: string;
    TECHNICAL_HELP: string;
    SELF_ALERT_HELP: string;
  };
  constructor(private Interface: any) {
    this.AppConfigDTD = {
      member_features: 'object',
      institution_media_paths: 'object',
      member_configs: {
        type: 'builder',
        typeDef: 'MemberConfigsBuilder'
      },
      LOGIN_HELP: 'object',
      ADVISING_HELP: 'object',
      TECHNICAL_HELP: 'object',
      SELF_ALERT_HELP: 'object'
    };
    this.initialize();
  }
  public initialize(): IApplicationConfigurationModel {
    this.Interface.implement(this.AppConfigDTD, {}, this.model);
    this.model.member_configs.HIPIconTheme = 'blue';
    return this.model;
  }

  updateStudentHelp() {
    _4.forEach(this.model.LOGIN_HELP.details, this.buildChannelmetadata);
    _4.forEach(this.model.ADVISING_HELP.details, this.buildChannelmetadata);
    _4.forEach(this.model.TECHNICAL_HELP.details, this.buildChannelmetadata);
    _4.forEach(this.model.SELF_ALERT_HELP.details, this.buildChannelmetadata);
  }

  buildChannelmetadata(val: IHelpType) {
    val.metadata = ChannelBuilderServant.build(val.channel, val.contact_display_value, val.contact_value);
  }

  public update(data: IApplicationConfigurationModel): IApplicationConfigurationModel {
    this.Interface.implement(this.AppConfigDTD, data, this.model);
    this.model.member_configs.HIPIconTheme = 'blue';
    this.updateStudentHelp();
    return this.model;
  }

  public isConfigLoaded(): boolean {
    return !_4.isEmpty(this.model.member_configs) && !_4.isEmpty(this.model.member_features);
  }
  public isFeatureEnabled(key: string): boolean {
    return _4.has(this.model.member_features, key) ? this.model.member_features[key] : false;
  }

  public getConfigProperty(key: string): string {
    return _4.has(this.model.member_configs, key) ? this.model.member_configs[key] : '';
  }

  public useIntakePoll() {
    return !_4.isEmpty(this.getConfigProperty('poll-intake_survey_id'));
  }

  public useFirstTermPoll() {
    return this.isFeatureEnabled('cat-first_term') && this.userIsFirstTermSource();
  }

  public userIsFirstTermSource() {
    return this.getConfigProperty('cat-first_term_source') === 'cat.FirstTerm';
  }

  public intakeOrFirstTermID() {
    return this.getConfigProperty('poll-intake_survey_id');
  }

  public productName(): string {
    return this.getConfigProperty('product');
  }

  public isProductFeatureEnabled(key: string): boolean {
    return this.isFeatureEnabled(key);
  }

  public getInstitutionMediaPath(key: string): string {
    return _4.has(this.model.institution_media_paths, key) ? this.model.institution_media_paths[key] : '';
  }

  public supportEmail(): string {
    return `NavigateStudentTechSupport@eab.com`;
  }

  public navIconTheme(): string {
    return this.getConfigProperty('HIPIconTheme');
  }
}

export class ApplicationConfigurationModel implements ng.IServiceProvider {
  public $get(Interface: any): IApplicationConfiguration {
    return new ApplicationConfiguration(Interface) as any;
  }
}

export interface ICiDetails {
  [key: string]: string;
}

export interface IDeploymentDetails {
  [key: string]: string;
}

export interface IRepositoryDetials {
  [key: string]: string;
}

export interface IApplicationDetails {
  ci: ICiDetails;
  deployment: IDeploymentDetails;
  environment: string;
  repository: IRepositoryDetials;
}

export class ApplicationDetails {
  private ciDetails: ICiDetails;
  private deploymentDetails: IDeploymentDetails;
  private environmentDetails: string;
  private repositoryDetails: IRepositoryDetials;

  get details() {
    return {
      ci: this.ciDetails,
      deployment: this.deploymentDetails,
      environment: this.environmentDetails,
      repository: this.repositoryDetails
    };
  }

  get ci() {
    return this.ciDetails;
  }

  get deployment() {
    return this.deploymentDetails;
  }

  get environment() {
    return this.environmentDetails;
  }

  get repository() {
    return this.repositoryDetails;
  }

  setDetails(config: IApplicationDetails) {
    const { ci, deployment, environment, repository } = config;
    this.ciDetails = ci;
    this.deploymentDetails = deployment;
    this.environmentDetails = environment;
    this.repositoryDetails = repository;
  }
}



// WEBPACK FOOTER //
// ./app/lib/models/app_config_model.ts